/** Simplified Chinese org-admin UI copy (sidebar, tabs, dialogs, billing tab). */

import {
  WC2026_ORG_BILLING_DISCLOSURE,
  WC2026_ORG_BILLING_DISCLOSURE_SHORT,
} from '../../../shared/constants/wc2026OrgBillingDisclosure.constants'

export const accountAdminCopyZh = {
  backToSite: '← 返回网站',
  ORG_DRAWER_PARENT_FALLBACK: '组织',
  FRIENDS_ENTRY_LABEL: '管理组织',
  FRIENDS_ENTRY_HINT: '品牌与成员',
  START_HERE: '开始使用',
  START_HERE_INTRO:
    '使用组织导航在「开始使用」「品牌」「成员」和「设置」之间切换，然后：',
  OPEN_MENU: '打开菜单',
  BRANDING: '品牌',
  MEMBERS: '成员',
  SETTINGS: '设置',
  PLAN_BILLING: '方案',
  PLAN_BILLING_INTRO:
    '在网页上升级组织方案、管理支付方式，并在 Stripe 客户门户中查看发票。',
  PLAN_BILLING_CURRENT: '当前方案',
  PLAN_BILLING_RENEWS: '续订或周期结束',
  PLAN_BILLING_STATUS: '订阅状态',
  PLAN_BILLING_UPGRADE_BUSINESS: '升级至 Business',
  PLAN_BILLING_UPGRADE_ENTERPRISE: '升级至 Enterprise',
  PLAN_BILLING_PORTAL: '管理账单与发票',
  PLAN_BILLING_WEB_ONLY: '方案功能仅在网页端可用。',
  INVOICE_DETAILS: '账单与发票',
  INVOICE_DETAILS_WEB_ONLY: '账单与发票仅在网页端可用。',
  MANAGE_PLAN_BILLING: '管理方案',
  COMPARE_PLANS: '比较方案',
  NO_ORG_TITLE: '尚无组织',
  NO_ORG_SUBTITLE: '创建一个以管理品牌与成员，或使用邀请码加入。',
  CREATE_PLACEHOLDER: '组织名称',
  CREATE_CTA: '创建组织',
  JOIN_PLACEHOLDER: '加入码',
  JOIN_CTA: '加入',
  MEMBER_ONLY_TITLE: '成员权限',
  MEMBER_ONLY_MESSAGE:
    '仅组织管理员可以更改品牌和设置。如需更新，请联系您的管理员。',
  MEMBER_INVITE_RETURN_TITLE: '您已加入此组织',
  MEMBER_INVITE_RETURN_MESSAGE:
    '此链接供尚未加入的队友使用。您已以成员身份登录，无需再次接受邀请。仅管理员可以更改品牌和设置。',
  B2B_LOGO_MAX_COUNT: 1,
  BRAND_IMAGERY_SECTION_TITLE: '品牌视觉',
  UPLOAD_LOGOS: '上传 Logo',
  LOGO_TILE_LABEL: '徽标',
  LOGO_TILE_EMPTY: '添加 Logo',
  BANNER_TILE_LABEL: '战队横幅',
  BANNER_TILE_EMPTY: '添加横幅',
  UPLOAD_BANNER: '上传横幅',
  REPLACE_BANNER: '更换横幅',
  REMOVE_BANNER: '移除横幅',
  REMOVE_BANNER_CONFIRM_TITLE: '移除此横幅？',
  REMOVE_BANNER_CONFIRM_MESSAGE: '战队将回退至品牌色渐变背景。',
  LOGOS_UPLOAD_LIMITS_PLACEHOLDER: '',
  LOGOS_UPLOAD_HINT:
    'PNG、JPG、WebP 或 SVG。最大 2MB。正方形（1:1），每边 512–1024px。建议使用透明 PNG。',
  BANNER_UPLOAD_HINT:
    'PNG、JPG 或 WebP。最大 2MB。宽屏 4:1 比例 — 建议 1600×400px，最小 1200×300px。',
  USE_BANNER_BACKGROUND_LABEL: '使用横幅图片作为战队背景',
  USE_BANNER_BACKGROUND_HINT:
    '开启后，战队主视觉将显示您的横幅图片，而非主色/辅色渐变。',
  USE_BANNER_BACKGROUND_DISABLED_HINT: '请先上传横幅图片以启用此开关。',
  USE_BANNER_BACKGROUND_SAVED: '已保存',
  REMOVE_LOGO: '移除',
  DOWNLOAD_LOGO: '下载',
  DOWNLOAD_LOGO_ERROR: '无法下载图片',
  REMOVE_LOGO_CONFIRM_TITLE: '移除此 Logo？',
  REMOVE_LOGO_CONFIRM_MESSAGE: '它将不再显示在您的组织中。',
  LOGO_FILE_TOO_LARGE: '该图片超过 2MB 上传限制。请尝试更小的文件。',
  SAVE_COLORS: '保存颜色',
  COLORS_SAVED: '颜色已保存',
  PRIMARY: '主色',
  SECONDARY: '辅色',
  COLOR_PRESETS: '预设',
  COLOR_PALETTE_LABEL: '调色板',
  COLOR_PALETTE_SATURATION_A11Y: '饱和度与亮度。拖动以选择颜色。',
  COLOR_PALETTE_HUE_A11Y: '色相。拖动以调整颜色。',
  CUSTOM_HEX_LABEL: '自定义（十六进制）',
  HEX_PLACEHOLDER: '#RRGGBB',
  JOIN_CODE: '加入码',
  SQUAD_JOIN_CODE: '战队加入码',
  ADD_MEMBERS_TITLE: '添加队友',
  ADD_MEMBERS_BODY:
    '分享下方的邀请链接。队友登录 Zporti 并打开链接即可加入此组织。',
  ADD_MEMBERS_BODY_WC_SINGLE_PRIMARY:
    '分享下方的邀请链接，让队友登录并加入此组织 — 他们将自动加入您关联的世界杯战队。对于组织外的亲友，请从世界杯 → 战队分享战队邀请（不要在此页面分享）。',
  MEMBERS_DIRECTORY: '成员目录',
  MEMBERS_ADMIN_HINT:
    '管理员可以管理品牌、成员和设置。在「操作」列中使用「设为管理员」「降级」或「移除」。',
  MEMBERS_TABLE_NAME: '姓名',
  MEMBERS_TABLE_EMAIL: '邮箱',
  MEMBERS_TABLE_ROLE: '角色',
  MEMBERS_TABLE_JOINED: '加入时间',
  MEMBERS_TABLE_ACTIONS: '操作',
  MEMBERS_TABLE_NO_ACTIONS_VISIBLE: '无操作',
  MEMBER_ACTION_LOADING_A11Y: '正在更新成员',
  MEMBERS_BULK_REMOVE_LOADING_A11Y: '正在移除所选成员',
  MEMBERS_TABLE_NO_ACTIONS_A11Y:
    '无操作。您无法编辑自己的行，或该成员暂无可更改项。',
  ROLE_LABEL_ADMIN: '管理员',
  ROLE_LABEL_MEMBER: '成员',
  MEMBERS_EMPTY: '尚无成员。',
  MEMBER_ROW_YOU_INLINE: '（您）',
  INVITE_LINK: '邀请链接',
  INVITE_LINK_HINT: '分享此链接，让队友登录并加入您的组织。',
  INVITE_LINK_HINT_WC:
    '此链接将打开组织加入流程。登录后，他们将同时加入组织和您关联的世界杯战队。',
  INVITE_LINK_QR_HINT: '使用手机相机扫描以打开此链接。',
  INVITE_LINK_QR_A11Y:
    '邀请链接的二维码。使用手机相机扫描以打开加入页面。',
  COPY_INVITE_LINK: '复制链接',
  VIEW_LINKED_SQUAD: '查看战队页面',
  VIEW_LINKED_SQUAD_A11Y: '打开关联的世界杯战队以预览结果',
  SEATS: '席位',
  SEATS_UNLIMITED: '不限',
  MAKE_ADMIN: '设为管理员',
  MAKE_ADMIN_TITLE: '将此成员设为管理员？',
  MAKE_ADMIN_MESSAGE: '他们将能够管理品牌、成员和组织设置。',
  DEMOTE_ADMIN: '降级',
  DEMOTE_ADMIN_TITLE: '降级此管理员？',
  DEMOTE_ADMIN_MESSAGE: '他们将保留成员访问权限，但失去管理员控制。',
  REMOVE_MEMBER: '移除',
  MEMBERS_BULK_SELECT: '多选',
  MEMBERS_BULK_CANCEL_SELECT: '取消选择',
  MEMBERS_BULK_REMOVE: '移除所选',
  MEMBERS_BULK_REMOVE_TITLE: '移除所选成员？',
  MEMBERS_BULK_REMOVE_MESSAGE:
    '他们将失去对此组织（及关联的世界杯战队，如有）的访问权限。此操作无法撤销。',
  MEMBERS_BULK_REMOVE_CONFIRM: '移除',
  MEMBERS_BULK_ROW_CHECKBOX_A11Y: '选择成员以批量移除',
  MEMBERS_BULK_CANCEL_DIALOG: '取消',
  MEMBERS_BULK_REMOVE_FAILED: '批量移除失败',
  MEMBERS_INVITE_LINK_COPIED: '链接已复制',
  membersBulkRemoveSummary: (removed: number, skipped: number) =>
    `已移除 ${removed} 人；跳过 ${skipped} 人`,
  membersBulkRemoveDone: (removed: number) => `已移除 ${removed} 人`,
  MEMBERS_BULK_SELECT_ALL_A11Y: '选择或取消选择除您以外的所有成员',
  ACCOUNT_NAME: '组织名称',
  SAVE_NAME: '保存名称',
  WC_LINKED_SQUAD_SECTION_TITLE: '关联的世界杯战队',
  WC_LINKED_SQUAD_SECTION_BODY_LINKED:
    '这与您在世界杯 → 战队中看到的战队相同。可在此或战队页面更改战队名称。从「成员」标签分享组织邀请链接：新成员先加入组织，自动加入此战队，然后打开战队。',
  WC_LINKED_SQUAD_SECTION_BODY_NOT_LINKED:
    '粘贴世界杯战队邀请码以将该战队关联到此组织。关联后，通过「成员」标签的组织邀请链接加入的用户将自动加入战队。',
  WC_LINKED_SQUAD_NAME_LABEL: '战队名称',
  WC_LINKED_SQUAD_INVITE_CODE_LABEL: '战队邀请码',
  WC_LINKED_SQUAD_CODE_PLACEHOLDER: '粘贴战队邀请码',
  WC_LINKED_SQUAD_SAVE_NAME: '保存战队名称',
  WC_LINKED_SQUAD_LINK_SQUAD: '关联战队',
  ORG_ONLY_JOIN_CODE_TITLE: '组织邀请',
  ORG_ONLY_JOIN_CODE_BODY:
    '分享邀请链接，让人们先加入组织；他们将自动加入战队，并可通过世界杯 → 战队打开。',
  COPY_ORG_INVITE_LINK: '复制邀请链接',
  PLAN_TIER: '方案',
  MEMBERSHIP_POLICY_TITLE: '成员上限',
  MEMBERSHIP_POLICY_UNLIMITED_LABEL: '不限成员数',
  MEMBERSHIP_POLICY_UNLIMITED_APPROVED_HELP:
    'Zporti 审批通过后，此组织已启用不限邀请链接加入。',
  MEMBERSHIP_POLICY_FROM_PLAN_HELP:
    '您的方案包含不限邀请链接成员数。无需额外操作。',
  MEMBERSHIP_POLICY_PENDING_HELP:
    '您的请求正在审核中。Zporti 审核通过后将启用不限成员数。',
  MEMBERSHIP_POLICY_LIMITED_HELP:
    '取消勾选后，邀请链接加入将受席位上限限制（Starter 默认 100）。',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_TITLE: '申请不限成员数？',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_MESSAGE:
    '这将向 Zporti 发送请求。我们将审核并为您的组织启用不限邀请链接成员数。在此之前，您可继续使用当前的席位上限。现在发送请求？',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_CONFIRM: '发送请求',
  MEMBERSHIP_POLICY_REQUEST_SENT: '请求已发送',
  MEMBERSHIP_POLICY_CANCEL_REQUEST_LINK: '取消请求',
  MEMBERSHIP_POLICY_CANCEL_DIALOG_TITLE: '取消不限成员数请求？',
  MEMBERSHIP_POLICY_CANCEL_DIALOG_MESSAGE:
    '这将撤回您的待处理请求。Zporti 将收到您已取消的通知。',
  MEMBERSHIP_POLICY_CANCEL_CONFIRM: '取消请求',
  MEMBERSHIP_POLICY_CANCEL_DONE: '请求已取消',
  BILLING_GATE_LOCKED_TITLE: '完成账单设置后解锁',
  BILLING_GATE_LOCKED_BODY:
    '设置组织方案以访问品牌、成员和设置。',
  BILLING_GATE_GO_TO_BILLING: '前往方案',
  DEACTIVATE: '停用组织',
  DEACTIVATE_CONFIRM_TITLE: '停用组织？',
  DEACTIVATE_CONFIRM_MESSAGE:
    '成员将失去组织权益，直至支持团队重新激活该组织。',
  INACTIVE_TITLE: '已停用',
  INACTIVE_BODY:
    '此组织已停用。如为误操作，您可以重新激活。',
  REACTIVATE: '重新激活',
  REMOVE_MEMBER_TITLE: '移除成员？',
  REMOVE_MEMBER_MESSAGE: '他们将失去对此组织的访问权限。',
  LEAVE_ORG_TITLE: '离开此组织？',
  LEAVE_ORG_MESSAGE:
    '您将失去此组织的品牌和成员工具访问权限。之后您可以创建或加入其他组织。',
  LEAVE_ORG_CONFIRM: '离开组织',
  LEAVE_ORG_MEMBER_HINT:
    '如需停止使用此组织的权益，您可以离开。管理员可通过邀请再次添加您。',
  LEAVE_ORG_DONE_TITLE: '您已离开组织',
  LEAVE_ORG_DONE_MESSAGE: '您可在此页面创建新组织或使用邀请码加入。',
  LEAVE_ORG_SOLE_ADMIN_HINT:
    '您是唯一的管理员。请先在「成员」中将另一位成员设为管理员，然后即可离开。',
  DEACTIVATE_PERMANENT_DELETE_FOOTNOTE:
    '停用后，「离开组织」下方将出现永久删除区域，需填写确认字段。',
  DELETE_ORG_SECTION_TITLE: '永久删除',
  DELETE_ORG_SECTION_BODY:
    '这将从我们的系统中移除该组织及所有成员关系。请准确输入以下短语：小写 delete、一个空格，然后与您保存的组织名称完全一致。',
  DELETE_ORG_NAME_LABEL: '准确输入此短语',
  DELETE_ORG_BUTTON: '永久删除组织',
  DELETE_ORG_DIALOG_TITLE: '永久删除此组织？',
  DELETE_ORG_DIALOG_MESSAGE:
    '此操作无法撤销。所有成员将失去访问权限，品牌数据将被移除。',
  setupGuide: {
    TITLE: '建议设置顺序',
    LINE_BRANDING_BEFORE: '设置您的',
    LINE_BRANDING_LINK: 'Logo 与品牌颜色',
    LINE_BRANDING_AFTER: '，以便成员识别您的组织。',
    LINE_MEMBERS_BEFORE: '从',
    LINE_MEMBERS_AFTER: ' 使用邀请链接或加入码邀请团队。',
    LINE_SETTINGS_BEFORE: '在',
    LINE_SETTINGS_AFTER: ' 中查看组织名称和方案。',
  },
  navShort: {
    START_HERE: '开始',
    BRANDING: '品牌',
    MEMBERS: '成员',
    SETTINGS: '设置',
    PLAN_BILLING: '方案',
    INVOICE_DETAILS: '账单',
  },
  navLockedA11ySuffix: ' — 完成账单设置后解锁',
  brandingPreview: {
    SECTION_LABEL: '预览',
    SQUAD_PLACEHOLDER_NAME: '您的战队',
    COMPANY_NAME_PLACEHOLDER: '您的组织',
    COLOR_PRIMARY_LABEL: '主色',
    COLOR_SECONDARY_LABEL: '辅色',
    HERO_BACK_LABEL: '战队',
    HERO_COMPANY_GROUP_LABEL: '公司战队',
    HERO_EMPLOYEES_LABEL: '名成员',
  },
  sso: {
    TITLE: '公司登录 (SSO)',
    BODY:
      '将此组织限制为使用特定公司邮箱域名的用户。启用后，使用该域名通过 Google 登录的新成员将自动加入——无需邀请链接。现有成员不受影响。',
    CHECKBOX_LABEL: '限制为公司邮箱域名',
    DOMAIN_PLACEHOLDER: 'acme.com',
    SAVE_BUTTON: '保存 SSO 设置',
    INVALID_DOMAIN: '请输入有效域名（例如 acme.com）',
    domainRestricted: (domain: string) => `已限制域名 @${domain}`,
    DOMAIN_REMOVED: '已移除域名限制',
    SAVE_FAILED: '无法保存 SSO 设置',
  },
  billing: {
    ORGANIZATION_PLAN_LABEL: '组织方案',
    PLAN_PICKER_HEADING: '选择您的方案',
    PLAN_PICKER_SUBHEADING:
      'WC 2026 一次性组织访问——赛事期间的品牌、成员席位与关联球队。',
    PLAN_BUSINESS_NAME: 'Business',
    PLAN_BUSINESS_PRICE: '起价 $450',
    PLAN_BUSINESS_TAGLINE:
      '自助一次性组织费用。选择席位档位并一次性支付 WC 2026 赛事访问权限。',
    ORG_BILLING_DISCLOSURE: WC2026_ORG_BILLING_DISCLOSURE,
    ORG_BILLING_DISCLOSURE_SHORT: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    PLAN_BUSINESS_CTA: '立即开始',
    PLAN_ENTERPRISE_NAME: 'Enterprise',
    PLAN_ENTERPRISE_PRICE: '定制',
    PLAN_ENTERPRISE_TAGLINE:
      '大型组织的定制定价。联系我们，我们将为您制定合适的方案。',
    PLAN_ENTERPRISE_CTA: '联系我们',
    CUSTOM_FORM_NAME_LABEL: '您的姓名',
    CUSTOM_FORM_NAME_PLACEHOLDER: '张三',
    CUSTOM_FORM_EMAIL_LABEL: '工作邮箱',
    CUSTOM_FORM_EMAIL_PLACEHOLDER: 'zhangsan@company.com',
    CUSTOM_FORM_MESSAGE_LABEL: '留言（可选）',
    CUSTOM_FORM_MESSAGE_PLACEHOLDER: '请介绍您的组织及需求。',
    CUSTOM_FORM_SUBMIT: '发送咨询',
    CUSTOM_FORM_SENT: '我们会尽快与您联系！',
    PERSONAL_PLAN_LABEL: '个人方案',
    ENTERPRISE_QUOTE_LABEL: 'Enterprise 协议价',
    MANAGE_PORTAL: '管理组织账单',
    MANAGE_PERSONAL_PORTAL: '管理个人订阅',
    COMPARE_PLANS: '比较方案',
    SUBSCRIPTION_STATUS: '订阅状态',
    PERIOD_END: '续订或周期结束',
    PERSONAL_BILLING_SECTION: '个人订阅',
    ORG_BILLING_SECTION: '组织订阅',
    STRIPE_NOT_CONFIGURED:
      '账单功能正在配置中。方案详情即将可用。',
    B2B_BILLING_RETURN_SYNCING: '正在应用您的 Stripe 付款…',
    B2B_BILLING_RETURN_SYNCING_A11Y: '正在应用您的 Stripe 付款',
    ORG_SEAT_TIER_LABEL: '席位档位',
    ORG_CURRENT_SEAT_TIER_LABEL: '当前席位档位',
    UPGRADE_SEAT_TIER: '升级',
    SEAT_TIER_UPGRADE_DIALOG_TITLE: '升级席位档位？',
    SEAT_TIER_UPGRADE_DIALOG_CONFIRM: '继续结账',
    SEAT_TIER_UPGRADE_DIALOG_CANCEL: '取消',
    SEAT_TIER_UPGRADE_DIALOG_CURRENT_PREFIX: '当前席位档位：',
    SEAT_TIER_UPGRADE_DIALOG_TARGET_PREFIX: '升级至：',
    SEAT_TIER_UPGRADE_DIALOG_REFUND_BODY:
      '您已为当前（较低）席位档位付款。Stripe 将把该笔费用中未使用部分抵扣或退还至本次升级，因此结账金额反映净额（按比例调整）。',
    SEAT_TIER_UPGRADE_DIALOG_SCOPE_REMINDER: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    SEAT_TIER_UPGRADE_DIALOG_CONTINUE_PROMPT: '继续？',
    NEED_CUSTOM_PLAN: '需要定制方案？',
    NEED_CUSTOM_PLAN_A11Y: '定制方案',
    PLAN_TIER_STARTER: 'Starter（免费）',
    PLAN_TIER_PRO: 'Pro',
    PLAN_TIER_BUSINESS: 'Business',
    PLAN_TIER_ENTERPRISE: 'Enterprise',
    SUBSCRIPTION_STATUS_ACTIVE: '有效',
    SUBSCRIPTION_STATUS_TRIALING: '试用中',
    SUBSCRIPTION_STATUS_PAST_DUE: '逾期',
    SUBSCRIPTION_STATUS_CANCELED: '已取消',
    SUBSCRIPTION_STATUS_UNPAID: '未付款',
    SUBSCRIPTION_STATUS_INCOMPLETE: '未完成',
    SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED: '已过期',
    SUBSCRIPTION_STATUS_PAUSED: '已暂停',
  },
} as const
